module.exports = __webpack_public_path__ + "img/logo0.0adb1df5.png";